import React from 'react';

import t from '../../../labels/labelling-utils';
import { COLOR_SCHEMA_LIGHT, ColorSchema, COMPONENT_SIZE_RESPONSIVE } from '../../../typings/design-tokens';
import { IComponent } from '../../../typings/generic-component';
import { applyColorSchema, makeClassNames } from '../../../utils/styles';
import './round-group.scss';

export interface IRoundGroup extends IComponent {
  name: string;
}

const classNames = (colorSchema: ColorSchema) =>
  makeClassNames({
    roundGroup: ['round-group', `${applyColorSchema('round-group', colorSchema)}`],
    roundGroupName: ['round-group__name', `${applyColorSchema('round-group__name', colorSchema)}`],
    roundGroupLabel: 'round-group__label',
  });

const RoundGroup = ({
  /* istanbul ignore next: default value */ colorSchema = COLOR_SCHEMA_LIGHT,
  /* istanbul ignore next: default value */ size = COMPONENT_SIZE_RESPONSIVE,
  name,
}: IRoundGroup) => {
  const cn = classNames(colorSchema);
  return (
    <span className={cn.roundGroup} data-size={size}>
      <span className={cn.roundGroupLabel}>{t('results.match.round.group')}</span>
      <span className={cn.roundGroupName}>{name}</span>
    </span>
  );
};

export default RoundGroup;
